module.exports = __webpack_public_path__ + "img/mitarbeiter.95f21075.svg";